import React from "react";
import HomeButton from "./HomeButton";
import EmptySection from "./EmptySection";

export default function NotFound(){
	let sectionProps = {
		className: "not-found",
		src: "/images/404.svg",
		header: "Oops!",
		message: "Sorry, we can’t find this page",

		buttons: <HomeButton />,
	};

	return <EmptySection {...sectionProps} />;
}
